import { CloseIcon } from 'assets/icons/CloseIcon'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { addWorkScheduleModel, editWorkScheduleModel } from 'features/shifts/shiftsSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import { IWorkScheduleModelPostPatchRequest } from 'types/api/shiftsApi.interface'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const WorkScheduleModelModal = ({ closeModal, value }: { closeModal: any, value?: IWorkScheduleModelPostPatchRequest }) => {
    const [state, setState] = useState<IWorkScheduleModelPostPatchRequest>(value || {
        name: '',
        workDaysCount: null,
        restDaysCount: null
    })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        const resp = await dispatch(value?.id ? editWorkScheduleModel(state) : addWorkScheduleModel(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, valueAsNumber } = e.target
        setState(prev => ({ ...prev, [name]: name == 'name' ? value : valueAsNumber }))
    }

    return <Modal black>
        <Flex column between center gap='1rem' >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Work Schedule Model</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input placeholder='Summer model...' labelText='Model name' name='name' value={state.name} onChange={handleChange} nomarg invalid={!state.name} />
                <Input type='number' placeholder='5' labelText='Work Days Count' name='workDaysCount' value={state.workDaysCount} onChange={handleChange} nomarg invalid={!state.workDaysCount} />
                <Input type='number' placeholder='2' labelText='Rest Days Count' name='restDaysCount' value={state.restDaysCount} onChange={handleChange} nomarg invalid={!state.restDaysCount} />
            </Flex>
            <Button disabled={!state.name || !state.workDaysCount || !state.restDaysCount} orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

